export const noActionNotifications = [
	'instance:deleted',
	'instance:updated',
	'invitation:accepted',
	'instance:access-updated',
	'instance:revoked',
]

export const getRoute = function (notification, tld = "com") {
	if (!notification.group || !notification.group.includes(':') || noActionNotifications.includes(notification.group) || notification.isActionPerformed) {
		return notification
	}
	switch (notification.group) {
		case 'instance:created':
			notification.setInstance = true
			notification.action = 'Go to Instance';
			notification.route = `https://admin.bildhive.${tld}/select/${notification.data?.instance}`;
			notification.redirect = `/select/${notification.data?.instance}`
			break;

		case 'payment:card-declined':
			notification.action = 'Update Payment Method';
			notification.route = `https://admin.bildhive.${tld}/settings/billing?instance=${notification.data?.instance}&invoice=${notification.data?.invoice}`;
			notification.redirect = `/settings/billing?instance=${notification.data?.instance}&invoice=${notification.data?.invoice}`
			break;

		case 'instance:invite':
			notification.action = 'Accept';
			notification.action2 = 'Decline';
			notification.action2Type = 'danger';
			break;

		case 'task:assigned':
			notification.setInstance = true
			notification.action = 'View Task';
			notification.route = `https://contacts.bildhive.${tld}/tasks?id=${notification.data?.task}`;
			notification.redirect = `/tasks?id=${notification.data?.task}`
			break;

		case 'task:due-today':
			notification.setInstance = true
			notification.action = 'View Task';
			notification.route = `https://contacts.bildhive.${tld}/tasks?id=${notification.data?.task}`;
			notification.redirect = `/tasks?id=${notification.data?.task}`
			break;

		case 'task:daily-digest':
			notification.setInstance = true
			notification.action = 'View Tasks';
			notification.route = `https://admin.bildhive.${tld}/tasks-dashboard`;
			notification.redirect = `/tasks-dashboard`
			break;

		case 'broadcast:too-many-bounces':
			notification.setInstance = true
			notification.action = 'Review Lead List';
			notification.route = `https://contacts.bildhive.${tld}/leads?status=bounced`;
			notification.redirect = `/leads?status=bounced`;
			break;

		case 'form:new-leads-count':
			notification.setInstance = true
			notification.action = 'View Leads';
			notification.route = `https://contacts.bildhive.${tld}/leads?_sort=updatedAt:DESC`;
			notification.redirect = `/leads?_sort=updatedAt:DESC`;
			break;

		case 'contact:assigned':
		case 'contact:new-lead':
			notification.setInstance = true
			notification.action = 'View Lead';
			let queryParams = '';
			if (notification.data?.form) {
				queryParams += `?tab=forms&id=${notification.data.form}`;
			}
			notification.route = `https://contacts.bildhive.${tld}/leads/${notification.data?.contact}${queryParams}`;
			notification.redirect = `/leads/${notification.data?.contact}${queryParams}`
			break;
		case 'appointment:scheduled':
			notification.setInstance = true
			notification.action = 'View calendar';
			notification.route = `https://contacts.bildhive.${tld}/calendar?id=${notification.data?.appointment}`;
			notification.redirect = `/calendar?id=${notification.data?.appointment}`;
			break;
		case 'appointment:reminder':
		case 'appointment:booked':
		case 'appointment:cancelled':
		case 'appointment:updated':
			notification.setInstance = true
			notification.action = 'View';
			notification.route = `https://contacts.bildhive.${tld}/appointments?id=${notification.data?.appointment}`;
			notification.redirect = `/appointments?id=${notification.data?.appointment}`;
			break;
		case 'worksheet:submitted':
		case 'worksheet:approved':
		case 'worksheet:declined':
		case 'worksheet:sold':
			notification.setInstance = true
			notification.action = 'View Worksheet';
			notification.route = `https://worksheets.bildhive.${tld}/edit/${notification.data?.worksheet}`;
			notification.redirect = `/edit/${notification.data?.worksheet}`;
			break;
		case 'reservation:payment-received':
			notification.setInstance = true
			notification.action = 'View Reservation';
			if (notification.data?.worksheet) {
				notification.route = `https://worksheets.bildhive.${tld}/edit/${notification.data?.worksheet}`;
				notification.redirect = `/edit/${notification.data?.worksheet}`;
			} else {
				notification.route = `https://transactions.bildhive.${tld}/reservation/${notification.data?.reservation}`;
				notification.redirect = `/reservation/${notification.data?.reservation}`;
			}
			break;
		case 'import:failed':
			notification.setInstance = true
			notification.action = 'View Import';
			notification.route = `https://contacts.bildhive.${tld}/settings?import=true`;
			notification.redirect = `/settings?import=true`;
			break;
		case 'import:failed:lot':
			notification.setInstance = true
			notification.action = 'View Import';
			notification.route = `https://siteplan.bildhive.${tld}/settings?tab=manageData&History=true`;
			notification.redirect = `/settings?tab=manageData&History=true`;
			break;
		case 'import:failed:unit':
			notification.setInstance = true
			notification.action = 'View Import';
			notification.route = `https://models.bildhive.${tld}/settings?tab=manageData&History=true`;
			notification.redirect = `/settings?tab=manageData&History=true`;
			break;
		case 'import:failed:addon':
		case 'import:failed:condo-unit':
			notification.setInstance = true
			notification.action = 'View Import';
			notification.route = `https://condogrid.bildhive.${tld}/settings?tab=manageData&History=true`;
			notification.redirect = `/settings?tab=manageData&History=true`;
			break;
		case 'sms:new-message':
			notification.setInstance = true
			notification.action = 'View SMS/MMS';
			notification.route = `https://contacts.bildhive.${tld}/leads/${notification.data.contact}?tab=sms&id=${notification.data.smsMessage}`;
			notification.redirect = `/leads/${notification.data.contact}?tab=sms&id=${notification.data.smsMessage}`;
			break;
	}

	return notification;
}
